import { Api } from '../api';
import { misc } from '../endpoints';
import type { ApprovePasswordRequest, GetContactsResponse, GetDictionariesResponse } from './models';

export class MiscApi extends Api {
  static getContacts = (signal?: AbortSignal) => this.get<GetContactsResponse>(misc.contacts(), { signal });

  static getDictionaries = (signal?: AbortSignal) => this.get<GetDictionariesResponse>(misc.dictionaries(), { signal });

  static approvePassword = (request: ApprovePasswordRequest, signal?: AbortSignal) =>
    this.post<null>(misc.password(), request, { responseType: 'none', signal });
}
